"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
function subscriptionSocket(createSocket) {
    const socket = createSocket();
    return Object.assign(Object.assign({}, socket), { subscribe(message) {
            return __asyncGenerator(this, arguments, function* subscribe_1() {
                var e_1, _a;
                let resubscribeTimer = setTimeout(subscribeRequest, 0);
                function subscribeRequest() {
                    var _a;
                    return __awaiter(this, void 0, void 0, function* () {
                        clearTimeout(resubscribeTimer);
                        const response = yield socket.request(message);
                        resubscribeTimer = setTimeout(subscribeRequest, ((_a = response.expireTime) !== null && _a !== void 0 ? _a : 0) - Date.now());
                    });
                }
                const filterAddress = Object.assign(Object.assign(Object.assign({ locationId: null }, message.locationAddress), message.unitAddress), message.dataSourceAddress);
                if (message.locationAddress || message.dataSourceAddress) {
                    throw new Error('The subscribe function currently only supports unitAddress.');
                }
                const generator = socket.watch();
                try {
                    try {
                        for (var generator_1 = __asyncValues(generator), generator_1_1; generator_1_1 = yield __await(generator_1.next()), !generator_1_1.done;) {
                            const data = generator_1_1.value;
                            if (isSubscriptionData(data, filterAddress)) {
                                yield yield __await(data);
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (generator_1_1 && !generator_1_1.done && (_a = generator_1.return)) yield __await(_a.call(generator_1));
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                finally {
                    clearTimeout(resubscribeTimer);
                    generator.return();
                }
            });
        } });
}
exports.default = subscriptionSocket;
function isSubscriptionData(data, filterAddress) {
    var _a, _b, _c, _d, _e, _f;
    return (data.messageType === 'SubscribeData' &&
        (!filterAddress.locationId ||
            data.locationId === filterAddress.locationId ||
            (((_a = data.list) === null || _a === void 0 ? void 0 : _a[0].resourceType) === 'SampleList' &&
                ((_c = (_b = data.list) === null || _b === void 0 ? void 0 : _b[0].dataSourceAddress) === null || _c === void 0 ? void 0 : _c.locationId) === filterAddress.locationId) ||
            (((_d = data.list) === null || _d === void 0 ? void 0 : _d[0].resourceType) === 'EventDTO' &&
                ((_f = (_e = data.list) === null || _e === void 0 ? void 0 : _e[0].unitAddress) === null || _f === void 0 ? void 0 : _f.locationId) === filterAddress.locationId)));
}
//# sourceMappingURL=subscriptionSocket.js.map